import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import Cross from '@deliveroo/icon-set/react/Cross';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import i18n from '../../utils/i18n';

import styles from './FlexModal.scss';

export default class FlexModal extends React.Component {
  componentDidMount() {
    Modal.setAppElement(this.props.appElement);
  }

  render() {
    const { isOpen, dismissHandler, title, children, footer } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={dismissHandler}
        closeTimeoutMS={300}
        className={{
          base: styles.modal,
          afterOpen: styles.modalAfterOpen,
          beforeClose: styles.modalBeforeClose,
        }}
        overlayClassName={{
          base: styles.modalOverlay,
          afterOpen: styles.modalOverlayAfterOpen,
          beforeClose: styles.modalOverlayBeforeClose,
        }}
      >
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
            <h3 className={styles.modalTitle}>{title}</h3>
            {dismissHandler && (
              <a onClick={dismissHandler} className={styles.closeButton} href="#close">
                <Icon component={Cross} size={18}>
                  {i18n.gettext('Close')}
                </Icon>
              </a>
            )}
          </div>
          <div className={styles.modalBody}>{children}</div>
          {footer && <div className={styles.modalFooter}>{footer}</div>}
        </div>
      </Modal>
    );
  }
}

FlexModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  dismissHandler: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  footer: PropTypes.node,
  appElement: PropTypes.string.isRequired,
};

FlexModal.defaultProps = {
  footer: undefined,
};
